import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    itemTextDashboard: {
      fontWeight: 400,
    },
    listItemActive: {
      backgroundColor: '#E5F7F7',
      color: theme.palette.primary.main,
      '& .finance-icon': {
        fill: 'none !important',
        stroke: theme.palette.primary.main,
      },
      '& path': {
        fill: theme.palette.primary.main,
      },
    },
    listItem: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      borderRadius: 19,
      padding: '20px 36px',
      width: '100%',
      textTransform: 'none',
      marginBottom: theme.spacing(8),

      transition: theme.transitions.create(['background-color', 'color', 'fill'], {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.short,
      }),
      '& path': {
        transition: theme.transitions.create(['fill'], {
          easing: theme.transitions.easing.easeInOut,
          duration: theme.transitions.duration.short,
        }),
      },
      '&:hover': {
        backgroundColor: '#E5F7F7',
        color: theme.palette.primary.main,
        '& .finance-icon': {
          fill: 'none !important',
          stroke: theme.palette.primary.main,
        },
        '& path': {
          fill: theme.palette.primary.main,
        },
      },
    },
    itemIcon: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      '&:hover': {
        background: 'none',
      },
      '&:active': {
        background: 'none',
      },
      padding: 0,
      margin: ({ direction }: LayoutDirection) => direction === 'rtl' ? '0 0 0 23px' : '0 23px 0 0'
    },
    itemText: {
      textAlign: ({ direction }: LayoutDirection) => direction === 'rtl' ? 'right' : 'inherit'
    },
  })
);
